module.exports = __webpack_public_path__ + "static/media/starPartial_118.8b632864.png";